import React, { useEffect, useState } from "react";
import { getCurrentDateTimeLocal } from "../utils/constants";
import useSound from "use-sound";

import ping from "../assets/ping.mp3";
import moment from "moment";
import { unSettledBetsAPI } from "../service/AuthService";
import Select from 'react-select'


export default function CurrentBets() {
  const [sport, setSport] = React.useState("MATCHED");
  const [page, setPage] = React.useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [size, setSize] = useState(50);
  const [data, setData] = React.useState([]);
  const [search_, setSearch] = React.useState("");
  const [runnerNames, setRunnerNames] = React.useState([]);
  const [eventName, setEventName] = React.useState([]);
  const [filterPayload, setFilterPayload] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [filter, setFilter] = React.useState({});
  const [play] = useSound(ping);

  const getBetHistory = async (userName) => {
    setLoading(true);
    let payload = {
      betStatus: sport,
      pageNumber: page,
      pageSize: size,
      gameType: filter.market ? filter.market : undefined,
    };

    if (search_.length > 0) {
      payload["search"] = userName;
    }
    const { response: { content }, } = await unSettledBetsAPI(payload);
    console.log(content)
    let data_ = content.map((item, index) => ({
      ...item,
      bet_type: item.back_rate || item.back_run ? "Back" : "Lay",
      rate: item.back_run ? item.back_run : item.lay_run,
      "p/l": item.profit ? item.profit : item.loss,
    }));
    let data__ = JSON.parse(localStorage.getItem("betHistory"));
    if (localStorage.getItem("betHistory")) {
      if (content[0]?.created_date != data__[0]?.created_date) {
        sendNotification(
          "New Bet Placed",
          `Bet Placed on ${content[0]?.event_name} by ${content[0]?.userName}`
        );
        play();
      }
    }
    localStorage.setItem("betHistory", JSON.stringify(data_));

    setRunnerNames(
      Array.from(new Set(data_?.map((item) => item?.runner_name)))
    );
    setEventName(Array.from(new Set(data_?.map((item) => item?.event_name))));

    setData(data_);
    setLoading(false);
    // setCurrentPage(response?.response?.number);
    // setTotalPages(response?.response?.totalPages);
    // setTotalElements(response?.response?.totalElements);
    // setSize(response?.response?.size);

  };
  useEffect(() => {
    getBetHistory(search_);
  }, [size, page, search_]);

  const nextPage = () => {
    if (data.length > 0) {
      setPage(page + 1);
    }
  };
  const prevPage = () => {
    if (page > 0) {
      setPage(page - 1);
    }
  };
  const sendNotification = (title, body) => {
    play();
    if (Notification.permission === "granted") {
      new Notification(title, {
        body,
      });
    }
  };
  const enableNotification = () => {
    console.log("enableNotification");
    Notification.requestPermission();
  };
  const handleFilter = () => {
    let data_ = [...data];
    console.log("filterPayload", filterPayload);
    if (filterPayload.runnerName) {
      data_ = data_.filter(
        (item) => item.runner_name === filterPayload.runner_name
      );
    }
    if (filterPayload.eventName) {
      data_ = data_.filter(
        (item) => item.event_name === filterPayload.eventName
      );
    }
    if (filterPayload.betType) {
      data_ = data_.filter((item) => item.bet_type === filterPayload.betType);
    }
    if (filterPayload.userName) {
      data_ = data_.filter((item) => item.userName === filterPayload.userName);
    }
    if (filterPayload.bhav) {
      data_ = data_.filter((item) => item.rate === filterPayload.bhav);
    }
    if (filterPayload.fromDate) {
      data_ = data_.filter(
        (item) =>
          new Date(item.created_date).getTime() >=
          new Date(filterPayload.fromDate).getTime()
      );
    }
    if (filterPayload?.market == "BOOKMAKER_ODDS_1") {
      data_ = data_.filter((item) => item.marketName === filterPayload.market);
    } else {
      data_ = data_.filter((item) => item.marketName != "BOOKMAKER_ODDS_1");
    }
    if (filterPayload.toDate) {
      data_ = data_.filter(
        (item) =>
          new Date(item.created_date).getTime() <=
          new Date(filterPayload.toDate).getTime()
      );
    }

    setData(data_);
  };
  return (
    <>
      <div
        className="content-wrapper">

        {/* Content Header (Page header) */}
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>Current Bets</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active">Current Bets</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                {/* /.card */}
                <div className="card">
                  <form action="#" method="post" id="demoForm">
                    <div className="card-header">
                      <h4 className="text-capitalize">Current Bets</h4>
                      <div className="form-row align-items-center">
                        <div className="col-lg-3">
                          <div _ngcontent-ng-c3386150819="" className="">
                            <label _ngcontent-ng-c3386150819="">Team Name</label>
                            <Select
                              options={Array.from(
                                new Set(data?.map((item) => item?.event_name))
                              ).map((item) => ({
                                value: item,
                                label: item,
                              }))}
                              onChange={(e) =>
                                setFilterPayload({ ...filter, event_name: e.value })
                              }
                              _ngcontent-ng-c3386150819=""
                              name="s_type"
                              className="ng-untouched ng-pristine ng-valid"
                            >
                              {eventName?.map((item, index) => (
                                <option value={item}>
                                  {item +
                                    " " +
                                    moment(
                                      data?.find((item_) => item_?.event_name == item)
                                        ?.created_date + "Z"
                                    )
                                      ?.toDate()
                                      .toLocaleString()}
                                </option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <label _ngcontent-ng-c3386150819="">Market</label>
                          <select
                            onChange={(e) => {
                              setFilterPayload({
                                ...filterPayload,
                                market: e.target.value,
                              });
                            }}
                            _ngcontent-ng-c3386150819=""
                            name="s_type"
                            className="form-control form-select ng-untouched ng-pristine ng-valid"
                          >
                            <option value={"ALL"}>All</option>
                            <option value="FANCY">Fancy</option>
                            <option value="BOOKMAKER_ODDS_1">Bookmaker</option>
                          </select>
                        </div>
                        {filterPayload?.market === "FANCY" && (
                          <div
                            _ngcontent-ng-c3386150819=""
                            className="col-lg-3"
                          >
                            <div _ngcontent-ng-c3386150819="" className="input_block">
                              <label _ngcontent-ng-c3386150819="">Market</label>
                              <select
                                value={filterPayload.runner_name}
                                onChange={(e) =>
                                  setFilterPayload({
                                    ...filterPayload,
                                    runner_name: e.target.value,
                                  })
                                }
                                _ngcontent-ng-c3386150819=""
                                name="s_type"
                                className="form-control form-select ng-untouched ng-pristine ng-valid"
                              >
                                <option value={""}>All</option>
                                {Array.from(
                                  new Set(
                                    data
                                      ?.filter((item) => {
                                        if (filter.event_name) {
                                          return item?.event_name == filter.event_name;
                                        } else {
                                          return item;
                                        }
                                      })
                                      .map((item) => item?.runner_name)
                                  )
                                )?.map((item, index) => (
                                  <option value={item}>{item}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        )}
                        <div
                          _ngcontent-ng-c3386150819=""
                          className="col-lg-2">
                          <div _ngcontent-ng-c3386150819="" className="input_block">
                            <label _ngcontent-ng-c3386150819="">Search</label>
                            <input
                              type="text"
                              value={search_}
                              className="form-control"
                              onChange={(e) => setSearch(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-2">
                          <label _ngcontent-ng-c3386150819="" style={{ opacity: '0' }}>.</label>
                          <div className="d-flex" style={{ gap: '3px' }}>
                            <button
                              _ngcontent-ng-c3386150819=""
                              type="button"
                              onClick={handleFilter}
                              className="btn btn-primary"
                            >
                              Submit
                            </button>
                            <button
                              _ngcontent-ng-c3386150819=""
                              style={{
                                marginLeft: "10px",
                              }}
                              type="button"
                              onClick={() => {
                                setFilterPayload({});
                                setFilter({});
                                getBetHistory();
                              }}
                              className="btn btn-danger"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>

                    </div>
                    {/* /.card-header */}
                    <div className="card-body">

                      <div _ngcontent-ng-c3386150819="" className="table-responsive">
                        <table _ngcontent-ng-c3386150819="" className="table table-bordered table-striped">
                          <thead _ngcontent-ng-c3386150819="">
                            <tr _ngcontent-ng-c3386150819="">
                              {/**/}
                              <th _ngcontent-ng-c3386150819="">Event Type </th>
                              <th _ngcontent-ng-c3386150819="">Event Name</th>
                              <th _ngcontent-ng-c3386150819="">Username</th>
                              <th _ngcontent-ng-c3386150819="">Runner Name</th>
                              <th _ngcontent-ng-c3386150819="">Bet Type</th>
                              <th _ngcontent-ng-c3386150819="">Run/Bhav</th>
                              <th _ngcontent-ng-c3386150819="">Amount</th>
                              <th _ngcontent-ng-c3386150819="">Place Date</th>
                              <th _ngcontent-ng-c3386150819="">Match Date</th>
                            </tr>
                          </thead>
                          <tbody _ngcontent-ng-c3386150819="">
                            {data
                              ?.filter((item) => {
                                if (filterPayload.runner_name) {
                                  return item.runner_name == filterPayload.runner_name;
                                } else {
                                  return item;
                                }
                              })
                              ?.map((item) => (
                                <tr
                                  _ngcontent-ng-c3386150819=""
                                  className={`odd ${item.bet_type == "Back" ? "back" : "lay"
                                    } ng-star-inserted`}
                                >
                                  {/**/}
                                  <td _ngcontent-ng-c3386150819="">{item?.event_type}</td>
                                  <td _ngcontent-ng-c3386150819="">{item.event_name}</td>
                                  <td _ngcontent-ng-c3386150819="">{item.userName}</td>
                                  <td _ngcontent-ng-c3386150819="">{item.runner_name}</td>
                                  <td _ngcontent-ng-c3386150819="">{item.bet_type}</td>
                                  <td _ngcontent-ng-c3386150819="">{item.rate}</td>
                                  <td _ngcontent-ng-c3386150819="">{item.amount}</td>
                                  <td _ngcontent-ng-c3386150819="">
                                    <div
                                      _ngcontent-ng-c3386150819=""
                                      className="Date_time_box"
                                    >
                                      {moment(item.created_date).format(
                                        "YYYY-MM-DD HH:mm:ss"
                                      )}
                                    </div>
                                  </td>
                                  <td _ngcontent-ng-c3386150819="">
                                    <div
                                      _ngcontent-ng-c3386150819=""
                                      className="Date_time_box"
                                    >
                                      {moment(item.created_date).format(
                                        "YYYY-MM-DD HH:mm:ss"
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        </div>
                        <div className="row">
                          <div className="col-sm-12 col-md-5">
                            <div
                              className="dataTables_info"
                              id="example1_info"
                              role="status"
                              aria-live="polite"
                            >
                              Showing &nbsp;
                              {currentPage * size + 1} to{" "}
                              {currentPage * size + size > totalElements
                                ? totalElements
                                : currentPage * size + size}{" "}
                              of {totalElements} entries
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-7">
                            <div
                              className="dataTables_paginate paging_simple_numbers"
                              id="example1_paginate"
                            >
                              <ul className="pagination justify-content-end align-items-center">
                                {/* Previous */}
                                <li
                                  className={`page-item ${currentPage === 0 ? "disabled" : ""
                                    }`}
                                >
                                  <button
                                    type="button"
                                    className="page-link"
                                    onClick={() => {
                                      if (currentPage > 0) {
                                        setCurrentPage(currentPage - 1);
                                      }
                                    }}
                                    disabled={currentPage === 0}
                                  >
                                    Previous
                                  </button>
                                </li>

                                {/* Current Page */}
                                <li className="page-item active">
                                  <span className="page-link">
                                    {currentPage + 1} / {totalPages}
                                  </span>
                                </li>

                                {/* Next */}
                                <li
                                  className={`page-item ${currentPage === totalPages - 1 ? "disabled" : ""
                                    }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => {
                                      if (currentPage < totalPages - 1) {
                                        setCurrentPage(currentPage + 1);
                                      }
                                    }}
                                    disabled={currentPage === totalPages - 1}
                                  >
                                    Next
                                  </button>
                                </li>
                              </ul>

                            </div>
                          </div>
                        </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
